import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { API } from '../App';
import { Quote, Briefcase, FileText } from 'lucide-react';

export default function SuccessStoriesPage() {
  const [stories, setStories] = useState([]);
  useEffect(() => { axios.get(`${API}/success-stories`).then(r => setStories(r.data.stories || [])).catch(() => {}); }, []);
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-12 max-w-6xl">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold mb-2">Real Career Journeys from Our Community</h1>
          <p className="text-gray-600">Real UAE job seekers we&apos;ve helped.</p>
        </div>

        {stories.length === 0 ? (
          <p className="text-center text-gray-500 py-12">No published stories yet — new stories will appear here soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="success-stories-grid">
            {stories.map(s => {
              const proof = s.proof_data_url || '';
              const proofIsPdf = (s.proof_mime || '').includes('pdf');
              return (
              <Card key={s.id} className="p-5 flex flex-col" data-testid={`story-${s.id}`}>
                {proof && !proofIsPdf && (
                  <a href={proof} target="_blank" rel="noopener noreferrer" data-testid={`story-proof-image-link-${s.id}`}>
                    <img src={proof} alt="Success proof" className="w-full h-40 object-cover rounded mb-3 hover:opacity-90 transition" loading="lazy" />
                  </a>
                )}
                {proof && proofIsPdf && (
                  <a href={proof} target="_blank" rel="noopener noreferrer"
                    className="flex items-center gap-2 mb-3 border rounded p-3 bg-red-50 hover:bg-red-100 transition"
                    data-testid={`story-proof-pdf-link-${s.id}`}>
                    <FileText className="w-8 h-8 text-red-600" />
                    <div className="text-sm">
                      <p className="font-semibold text-red-700">Job Offer / Proof PDF</p>
                      <p className="text-xs text-red-500">Click to open</p>
                    </div>
                  </a>
                )}
                {!proof && s.screenshot_url && (
                  <img src={s.screenshot_url} alt="Success" className="w-full h-40 object-cover rounded mb-3" loading="lazy" />
                )}
                <div className="flex items-center gap-2 mb-2 text-sm text-[#009639] font-semibold">
                  <Briefcase className="w-4 h-4" />{s.job_title}{s.company && ` @ ${s.company}`}
                </div>
                <p className="font-bold mb-1">{s.display_name}</p>
                <p className="text-xs text-gray-500 mb-1">Secured {s.date_secured}</p>
                {s.support_type && <p className="text-xs text-gray-500 mb-3 inline-block px-2 py-0.5 bg-gray-100 rounded-full w-fit" data-testid={`story-support-type-${s.id}`}>{s.support_type}</p>}
                <div className="flex-1 text-sm text-gray-700 relative pl-4">
                  <Quote className="w-4 h-4 text-gray-300 absolute -left-1 top-0" />
                  {s.story}
                </div>
                {s.social_url && (
                  <a href={s.social_url} target="_blank" rel="noopener noreferrer" className="mt-3 text-xs text-[#CE1126] hover:underline">
                    View original post →
                  </a>
                )}
              </Card>
              );
            })}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
